/**
 * Configuración por defecto del portal (sustituir por respuesta de API).
 * Derivado de la maqueta React (MOCK_HOSPITAL_CONFIG).
 */
export const DOCUMENT_TYPES = [
  { id: '1', name: 'D.N.I.', code: 'DNI' },
  { id: '2', name: 'Libreta Cívica', code: 'LC' },
  { id: '3', name: 'Libreta de Enrolamiento', code: 'LE' },
  { id: '4', name: 'Pasaporte', code: 'PASAPORTE' },
  { id: '5', name: 'Cédula de Identidad', code: 'CI' },
]

export const DEFAULT_HOSPITAL_CONFIG = {
  id: '1',
  primaryColor: '#00838F',
  secondaryColor: '#E0F2F1',
  nombreAplicacion: 'Portal del Paciente',
  iconoAplicacion: null,
  helpTextLogin: `
    <p>Bienvenido al <strong>Portal de Pacientes</strong>.</p>
    <p>Desde aquí podrá:</p>
    <ul>
      <li>Obtener turnos para usted y su familia</li>
      <li>Consultar los turnos asignados</li>
      <li>Ver los resultados de sus estudios</li>
    </ul>
  `,
  helpTextRegister: `
    <p>Complete el formulario para crear su cuenta.</p>
    <p>Recuerde que debe estar registrado previamente en el instituto para poder acceder.</p>
  `,
  helpTextAutogestion: '',
  helpTextPortal: '',
  htmlFooter: '',
  aceptaTerminosEnRegistro: true,
  portalPacienteImplementado: false,
  autogestionImplementada: false,
  permiteSacarTurno: false,
  termsAndConditionsUrl: '/terminos-y-condiciones',
  /** HTML mostrado en el diálogo del formulario de registro (p. ej. desde API). */
  termsAndConditionsHtml: `
    <p class="mb-2">Al utilizar el Portal de Pacientes usted acepta las siguientes condiciones de uso.</p>
    <p class="mb-2">El contenido de este documento es un ejemplo y deberá ser reemplazado por el texto legal vigente del instituto.</p>
    <ul class="pl-4 mb-2">
      <li>Uso responsable de la cuenta y de sus credenciales.</li>
      <li>Los datos consignados deben ser veraces.</li>
      <li>El instituto podrá suspender el acceso ante uso indebido.</li>
    </ul>
  `,
  privacyPolicyHtml: `
    <p class="mb-2">Información sobre el tratamiento de datos personales conforme a la normativa aplicable.</p>
    <p class="mb-2">Texto de ejemplo: sustituir por la política de privacidad oficial del instituto.</p>
  `,
}
